import { useMutation, MutationFunction, MutationOptions } from 'react-query';
import {
    CreateToolTypeBody,
    ToolTypeResponse,
    UpdateToolTypeBody,
    createToolType,
    updateToolType,
} from '../../services/apiSLTP/materials/toolsTypes';

type UseUpdateToolTypeMutationOptions = MutationOptions<ToolTypeResponse, Error, { toolTypeId: string; data: UpdateToolTypeBody }>;

type UseCreateToolTypeMutationOptions = MutationOptions<ToolTypeResponse, Error, CreateToolTypeBody>;

export const useUpdateToolTypeMutation = (options?: UseUpdateToolTypeMutationOptions) => {
    const mutationFn: MutationFunction<ToolTypeResponse, { toolTypeId: string; data: UpdateToolTypeBody }> = async ({ toolTypeId, data }) => {
        try {
            return await updateToolType(toolTypeId, data);
        } catch {
            throw new Error('An unexpected error occurred during tool type update');
        }
    };

    return useMutation(mutationFn, options);
};

export const useCreateToolTypeMutation = (options?: UseCreateToolTypeMutationOptions) => {
    const mutationFn: MutationFunction<ToolTypeResponse, CreateToolTypeBody> = async (data) => {
        try {
            return await createToolType(data);
        } catch {
            throw new Error('An unexpected error occurred during tool type creation');
        }
    };

    return useMutation(mutationFn, options);
};
